<template>
  <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="loading.page"
  >
    <a-table
      :rowKey="(record, index) => {return index;}"
      :columns="columns"
      :dataSource="getdataSource"
      :pagination="pagination"
      size="small"
      :scroll="{ x: 700 }"
      bordered
      >
      <template slot="title" >
        <div class="m-display-flex space-between">
          <div class="head-table">Purchase List</div>
          <a-button
            type="default"
            size="small"
            @click="getdetilPO('reload')"
          >
            <a-icon type="reload" />Reload
          </a-button>
        </div>
      </template>
      <template slot="no" slot-scope="text, record, index">
          {{index+1}}
      </template>
      <template slot="itemPN" slot-scope="text, record, index">
          <span>{{record.nama_barang}}</span>
          <br />
          <small><b>( {{record.type_item=="1" ? "ASET" : "ITEM"}} )</b></small>
      </template>
      <div slot="itemPPDtl" slot-scope="item">
        <h4>{{item.nama_barang}}</h4>
        <span
          >{{ item.pp_nama_barang }}
          {{ item.pp_kode_anggaran}}</span
        >
        <a-alert
          type="error"
          banner
          v-if="
            item.pp_kode_anggaran == null || item.pp_kode_anggaran == ''
          "
          message="item anggaran cannot be empty"
        />
      </div>
      <template slot="qty" slot-scope="text, record">
          {{record.quantity}} {{record.saruan}}
      </template>
      <template slot="harga" slot-scope="text, record">
          {{formatCurrency(record.currency, record.harga)}}
      </template>
      <template slot="total_harga" slot-scope="text, record">
          {{formatCurrency(record.currency, record.hargaTotal)}}
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-button-group>
          <a-button
            type="primary"
            @click="handleEditRow(record)"
          >
            <a-icon type="edit" />
          </a-button>
          <!-- <a-button type="danger" @click="handleRemoveRow(record)">
            <a-icon type="close" />
          </a-button> -->
        </a-button-group>
      </template>

      <!-- <template slot="footer" style="display:none!important"> -->
        <template style="display:none!important">
        <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <div class="m-price-total-refund">
                  <a-row :gutter="8" >
                    <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                      <h3 class="margin-remove m-text-align">Value Refund :</h3>
                    </a-col>
                    <a-col :span="14">
                      <h3 class="m-text-align">
                        <CurrencyJustified
                          :currencyValue="this.dataProcessed.information.nopowo.currency"
                          :valueNumber="valuerefund"/>
                      </h3>
                    </a-col>
                  </a-row>
                  <a-row :gutter="8" 
                    v-if="this.dataProcessed.information.nopowo.currency!=
                      this.dataProcessed.information.currency">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                      <h3 class="margin-remove m-text-align">Convertion Value :</h3>
                    </a-col>
                    <a-col :span="14">
                      <h3 class="m-text-align">
                        <CurrencyJustified
                          :currencyValue="this.dataProcessed.information.currency"
                          :valueNumber="valueConversion"/>
                      </h3>
                    </a-col>
                  </a-row>
              </div>
            </a-col>
          
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <div class="footer-list">
              <a-row :gutter="8" >
                <a-col :xs="{ span: 24 }" :lg="{ span:12 }">
                  <h3 class="margin-remove m-text-align right">Sub Total :</h3>
                </a-col>
                <a-col :span="12">
                  <h3 class="m-text-align">
                    <CurrencyJustified
                      :currencyValue="this.dataProcessed.information.nopowo.currency"
                      :valueNumber="totalPrice"/>
                  </h3>
                </a-col>
              </a-row>
            </div>
            <a-divider class="margin-bottom-small margin-top-small"/>
            <div v-for="item in getListDisc" :key="item.key" class="footer-list">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                  <div class="m-text-align right">
                    <span
                      v-if="item.cur_type !== 'percentage'"
                      class="m-text-align footer-list footer-light"
                      >{{ item.item_name }}</span
                    >
                    <span v-else class="m-text-align footer-list footer-light"
                      >{{ item.item_name }} ({{ item.harga + "%" }})</span
                    >
                  </div>
                </a-col>
                <a-col :span="2">
                  <a-button-group class="m-text-align right footer-list">
                    <a-button
                      type="primary"
                      size="small"
                      @click="handleEditModal(item)"
                    >
                      <a-icon type="edit" />
                    </a-button>
                    <!-- <a-button
                      type="danger"
                      size="small"
                      @click="handleRemoveRow(item)"
                    >
                      <a-icon type="close" />
                    </a-button> -->
                  </a-button-group>
                </a-col>
                <a-col :span="12">
                  <span
                    class="m-text-align footer-light"
                    :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                    v-if="item.cur_type !== 'percentage'"
                  >
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="item.unit_price"
                    />
                  </span>
                  <span
                    class="m-text-align footer-light"
                    :style="
                      (totalPrice * item.harga) / 100 < 0
                        ? 'color:red'
                        : 'color:black'
                    "
                    v-else
                  >
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="(totalPrice * item.harga) / 100"
                    />
                  </span>
                </a-col>
              </a-row>
            </div>
            <div class="footer-list">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <h3 class="margin-remove m-text-align right">
                    Total Discount :
                  </h3>
                </a-col>
                <a-col :span="12">
                  <h3 class="m-text-align">
                    <CurrencyJustified
                      :currencyValue="this.dataProcessed.information.nopowo.currency"
                      :valueNumber="totalDiscList"
                    />
                  </h3>
                </a-col>
              </a-row>
            </div>
            <a-divider class="margin-bottom-small margin-top-small"/>
            <div v-for="item in getListTax" :key="item.key" class="footer-list">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                  <div class="m-text-align right">
                    <span
                      v-if="item.cur_type !== 'percentage'"
                      class="m-text-align footer-list footer-light"
                      >{{ item.item_name }}</span
                    >
                    <span v-else class="m-text-align footer-list footer-light"
                      >{{ item.item_name }} ({{ item.harga + "%" }})</span
                    >
                  </div>
                </a-col>
                <a-col :span="2">
                  <a-button-group
                    class="m-text-align right footer-list footer-light"
                  >
                    <a-button
                      type="primary"
                      size="small"
                      @click="handleEditModal(item)"
                    >
                      <a-icon type="edit" />
                    </a-button>
                    <!-- <a-button
                      type="danger"
                      size="small"
                      @click="handleRemoveRow(item)"
                    >
                      <a-icon type="close" />
                    </a-button> -->
                  </a-button-group>
                </a-col>
                <a-col :span="12">
                  <span
                    class="m-text-align footer-light"
                    :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                    v-if="item.cur_type !== 'percentage'"
                  >
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="item.unit_price"
                    />
                  </span>
                  <span
                    class="m-text-align footer-light"
                    :style="
                      ((totalPrice - totalDiscList) * item.harga) / 100 < 0
                        ? 'color:red'
                        : 'color:black'
                    "
                    v-else
                  >
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="
                        ((totalPrice - totalDiscList) * item.harga) / 100
                      "
                    />
                  </span>
                </a-col>
              </a-row>
            </div>
            <div class="footer-list">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <h3 class="margin-remove m-text-align right">Total Tax :</h3>
                </a-col>
                <a-col :span="12">
                  <h3 class="m-text-align">
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="nilaiPajak"
                    />
                  </h3>
                </a-col>
              </a-row>
            </div>
            <a-divider class="margin-bottom-small margin-top-small"/>
            <div
              v-for="item in getListUsualShipp"
              :key="item.key"
              class="footer-list footer-light"
            >
              <a-row :gutter="8" class="margin-top">
                <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                  <div class="m-text-align right">
                    <span
                      v-if="item.cur_type !== 'percentage'"
                      class="m-text-align footer-list footer-light"
                      >{{ item.item_name }}</span
                    >
                    <span v-else class="m-text-align footer-list footer-light"
                      >{{ item.item_name }} ({{ item.harga + "%" }})</span
                    >
                  </div>
                </a-col>
                <a-col :span="2">
                  <div class="m-text-align center">
                    <a-button-group
                      class="m-text-align right footer-list footer-light"
                    >
                      <a-button
                        type="primary"
                        size="small"
                        @click="handleEditModal(item)"
                      >
                        <a-icon type="edit" />
                      </a-button>
                      <!-- <a-button
                        type="danger"
                        size="small"
                        @click="handleRemoveRow(item)"
                      >
                        <a-icon type="close" />
                      </a-button> -->
                    </a-button-group>
                  </div>
                </a-col>
                <a-col :span="12">
                  <span
                    class="m-text-align footer-light"
                    :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                    v-if="item.cur_type !== 'percentage'"
                  >
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="item.unit_price"
                    />
                  </span>
                  <span
                    class="m-text-align footer-light"
                    :style="
                      (totalPrice * item.harga) / 100 < 0
                        ? 'color:red'
                        : 'color:black'
                    "
                    v-else
                  >
                    <CurrencyJustified
                      :currencyValue="dataProcessed.information.nopowo.currency"
                      :valueNumber="(totalPrice * item.harga) / 100"
                    />
                  </span>
                </a-col>
              </a-row>
            </div>
            <a-statistic
              title="Grand Total"
              :value="formatCurrency(dataProcessed.information.nopowo.currency, grandTotal)"
              class="margin-top m-text-align right"
            />
          </a-col>
        </a-row>
      </template>
    </a-table>

    <a-modal
      v-model="editModal"
      @ok="handleEditModal"
      @cancel="handleClose"
      :maskClosable="false"
      :footer="null"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;Change </span>

      <a-form :form="modalForm">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Is Item?" hidden>
              <a-radio-group
                buttonStyle="solid"
                @change="handleis_item"
                :disabled="true"
                v-decorator="[
                  'is_item',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.is_item,
                  },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio-button value="yes">Yes</a-radio-button>
                <a-radio-button value="no">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-form-item label="Used For" v-if="trigered.is_item == 'no'">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'used_for',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.used_for,
                  },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="2">Tax</a-radio>
                <a-radio value="3">Shipping</a-radio>
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Category" hidden>
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'is_aset',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.type_item=='1' ? 'yes' : 'no',
                  },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio value="no">Item Inventory</a-radio>
                <a-radio value="yes">Item Aset</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item
          label="PP Detail"
           hidden
          v-if="
            this.trigered.is_item == 'yes' ||
            (this.trigered.is_item == 'no' && !this.trigered.disc)
          "
          :disabled="true"
        >
          <a-select
            showSearch
            allowClear
            @search="handleppdtl"
            optionFilterProp="children"
            :filterOption="filterOption"
            v-decorator="[
              'selectedPPdtl',
              {
                rules: [{ required: true }],
                initialValue: editData.selectedPPdtl,
              },
            ]"
            :disabled="true"
          >
            <a-select-option
              v-for="item in list_dtl_pp"
              :key="item.id_pp_dtl"
              :value="item.id_pp_dtl"
            >
              <table style="width: 100%">
                <tr>
                  <td>
                    <span
                      >{{ item.nama_barang }} - {{ item.kode_anggaran }}</span
                    >
                  </td>
                  <td>
                    <b style="float: right">
                      &nbsp;&nbsp;&nbsp;{{
                        formatCurrency(
                          item.currency,
                          parseFloat(item.nilai_dtl_pp)
                        )
                      }}
                    </b>
                  </td>
                </tr>
              </table>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Item PN" v-if="trigered.is_item == 'yes' && editData.type_item!=='1'"
          :hidden="dataProcessed.information.jns_transaksi!='po'">
          <v-select
            taggable
            clearable
            class="m-select"
            @input="handlePN"
            :options="dataPN"
            v-model="selectedPNm"
            label="item_pn_concat"
            :disabled="true"
          ></v-select>
        </a-form-item>
        <a-form-item label="Aset PN" v-if="trigered.is_item == 'yes' && editData.type_item=='1'"
          :hidden="dataProcessed.information.jns_transaksi!='po'">
          <v-select
            taggable
            clearable
            class="m-select"
            @input="handleAset"
            :options="dataAset"
            v-model="selectedPNm"
            label="item_pn_concat"
            :disabled="true"
          ></v-select>
        </a-form-item>
        <a-form-item label="Item Name">
          <a-input
            autocomplete="off"
            v-decorator="[
              'nama_barang',
              {
                rules: [{ required: true }],
                initialValue: editData.nama_barang,
              },
            ]"
            :disabled="true"
          ></a-input>
        </a-form-item>
        <a-row :gutter="8" v-if="trigered.is_item == 'yes'">
          <a-col :span="12">
            <a-form-item label="Quantity">
              <a-input-number
                :min="0"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: editData.jumlah,
                  },
                ]"
                @change="convertingmodalqty"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Unit">
              <a-auto-complete
                allowClear
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="[
                  'satuan',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.satuan,
                  },
                ]"
                :filterOption="filterOption"
                :disabled="true"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8" v-if="trigered.is_item == 'no'">
          <a-col :span="12">
            <a-form-item label="Option">
              <a-select
                v-decorator="[
                  'cur_type',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.cur_type,
                  },
                ]"
                @change="optionchange"
                :disabled="true"
              >
                <a-select-option value="currency">Nominal</a-select-option>
                <a-select-option value="percentage">Percentage</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Value"  hidden>
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: parseFloat(editData.harga),
                  },
                ]"
                @change="convertingmodalhrg"
               
                v-on:keydown.enter.prevent="preventEnterButtonModal"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Value" v-if="trigered.is_item == 'yes'"  hidden >
          <a-input-number
            type="number"
            :min="0"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'harga',
              {
                rules: [{ required: true }, { validator: checkPrice }],
                initialValue: parseFloat(editData.harga),
              },
            ]"
            @change="convertingmodalhrg"
            :disabled="true"
          />
        </a-form-item>
        <p v-if="editModal.matauang !== 'IDR'" class="margin-bottom"  hidden>
          Total value to IDR: {{ modalconvert_value }}
          <br />
        </p>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit(editData.key)"
            block
            type="danger"
            html-type="submit"
            v-decorator="['change']"
            ref="change"
            >Change</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "Detail-refundPayment",
  props: {
    type: String,
    dataProcessed: {},
    detilPO: {},
    isModifiedDtl: {},
  },
  mixins: [CurrencyFormat, GlobalMethod],
  components: {},
  data() {
    return {
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      loading:{
        page: false,
      },
      list_dtl_pp: {},
      editModal: false,
      editData: [],
      trigered: {
        used_for: false,
        pn: true,
        cur: false,
        qty_unit: true,
        is_item: "yes",
        percentage: false,
        disc: false,
      },
      dataPN:[],
      selectedPNm:[],
      modalconvert_value: 0,
      kurs: undefined,
      total_origin: undefined,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getAllMataUang",
      "getSatuan"
    ]),
    initialData() {
      return {
      };
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });

      return satuan;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          key: "no",
          width: 60,
          scopedSlots: {customRender: "no"},
          align: "right",
        },
        {
          title: "Item/Aset Name",
          dataIndex: "item_name",
          width: 250,
          scopedSlots: { customRender: "itemPN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detail",
          width: 250,
          scopedSlots: { customRender: "itemPPDtl" },
          sorter: (a, b) => a.pp_nama_barang.length - b.pp_nama_barang.length,
        },
        {
          title: "Quantity",
          dataIndex: "jumlah",
          key: "quantity",
          width: 100,
          scopedSlots: { customRender: "qty" },
          align: "right",
          sorter: (a, b) => a.jumlah.length - b.jumlah.length,
        },
        {
          title: "Values",
          align: "right",
          key: "harga",
          scopedSlots: { customRender: "harga" },
          width: 150,
        },
        {
          title: "Total Value",
          key: "amount",
          align: "right",
          scopedSlots: { customRender: "total_harga" },
          width: 150,
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 65,
          align:"center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getdataSource(){
      let data = this.detilPO ? this.detilPO.filter(
        (item) => item.is_item == "yes"
      ) : null;

      if (data) {
        data.forEach((value, index) => {
          data[index]["item_pn"] = value.item_pn;
          data[index]["item_name"] = value.nama_barang;
          data[index]["selectedPPdtl"] = data[index]["selectedPPdtl"]
            ? data[index]["selectedPPdtl"]
            : value.selectedPPdtl
            ? value.selectedPPdtl
            : "";
          data[index]["pp_nama_barang"] = data[index]["pp_nama_barang"]
            ? data[index]["pp_nama_barang"]
            : value.pp_nama_barang
            ? value.pp_nama_barang
            : "";
          data[index]["pp_kode_anggaran"] = data[index]["pp_kode_anggaran"]
            ? data[index]["pp_kode_anggaran"]
            : value.pp_kode_anggaran
            ? value.pp_kode_anggaran
            : "";
          data[index]["amount"] = this.formatCurrency(
            this.dataProcessed.information.nopowo.currency,
            value.hargaTotal
          );
          data[index]["quantity"] =
            value.jumlah + " " + value.satuan;
          data[index]["unit_price"] = this.formatCurrency(
            this.dataProcessed.information.nopowo.currency,
            value.harga
          );
          data[index]["no"] = index + 1;
          data[index]["key"] = "agrid" + (index + 1);
          data[index]["type_item"] = value.type_item;
        });
      }
      return data;
    },
    getCountList() {
      let data = this.detilPO ? this.detilPO.filter(
        (item) => item.is_item == "no"
      ) : null;
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.nama_barang;
          data[index]["unit_price"] = value.harga;
          data[index]["key"] =
            (value.used_for == "1" ? "bdisc" : "list") + (index + 1);
          data[index]["selectedPPdtl"] = value.selectedPPdtl;
        });
      }
      return data;
    },
    totalPrice() {
      let total = 0;
      if (this.getdataSource)
        this.getdataSource.forEach((item) => {
          total = total + item.hargaTotal;
        });

      return total;
    },
    getListDisc() {
      let data = this.detilPO ? this.detilPO.filter(
        (item) => item.is_item == "no" && item.used_for == "1"
      ) : null;
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.nama_barang;
          data[index]["unit_price"] = value.harga;
          data[index]["key"] = "bdisc" + (index + 1);
          data[index]["selectedPPdtl"] = value.selectedPPdtl;
        });
      }
      return data;
    },
    totalDiscList() {
      let total = 0;
      if (this.getCountList)
        this.getCountList.forEach((item) => {
          if (item.used_for == "1") {
            total = total + item.hargaTotal;
          }
        });

      return total;
    },
    getListTax() {
      let data = this.detilPO ? this.detilPO.filter(
        (item) => item.is_item == "no" && item.used_for == "2"
      ) : null;
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.nama_barang;
          data[index]["unit_price"] = value.harga;
          data[index]["key"] = "tax" + (index + 1);
          data[index]["selectedPPdtl"] = value.selectedPPdtl;
        });
      }
      return data;
    },
    totalPriceList() {
      let total = 0;
      //console.log("this.getCountList",this.getCountList)
      if(this.getCountList)
      this.getCountList.forEach((item) => {
        if (item.used_for == "4") {
          total = total + item.hargaTotal;
        }
      });

      return total;
    },
    nilaiPajak() {
      let tax = 0;
      if (this.getCountList)
      this.getCountList.forEach((item) => {
        if (item.used_for == "2") {
          if (item.cur_type == "percentage") {
            tax =
              tax +
              (parseFloat(item.harga) *
                (this.totalPrice - this.totalDiscList)) /
                100;
          } else {
            tax = tax + parseFloat(item.harga);
          }
        }
      });
      return tax;
    },
    totalShipping() {
      let shipping = 0;
      if(this.getCountList)
      this.getCountList.forEach((item) => {
        if (item.used_for == "3") {
          shipping = shipping + item.hargaTotal;
        }
      });
      return shipping;
    },
    getListUsualShipp() {
      let data = this.detilPO ? this.detilPO.filter(
        (item) =>
          item.is_item == "no" &&
          (item.used_for == "4" || item.used_for == "3")
      ): null;
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.nama_barang;
          data[index]["unit_price"] = value.harga;
          data[index]["key"] = "usualship" + (index + 1);
          data[index]["selectedPPdtl"] = value.selectedPPdtl;
        });
      }
      return data;
    },
    grandTotal() {
      return (
        this.totalPrice +
        this.totalPriceList +
        this.nilaiPajak +
        (this.totalShipping > 0 ? parseFloat(this.totalShipping) : 0) -
        this.totalDiscList
      );
    },
    valuerefund(){
      return (this.dataProcessed.information.nopowo.value_transaksi - 
        this.grandTotal).toFixed(2);
    },
    valueConversion(){
      let result = 0;
      if (this.dataProcessed.information.currency=="IDR" && 
        this.dataProcessed.information.nopowo.currency!="IDR"){
        result = this.valuerefund*this.dataProcessed.information.kurs;
      }else if(this.dataProcessed.information.currency=="USD" && 
        this.dataProcessed.information.nopowo.currency!="USD"){
        result = (this.dataProcessed.information.kurs*this.valuerefund).toFixed(2);
      }
      return result
    }
  },
  async created() {
    await this.getPN(null);
    await this.getAset(null);
  },
  methods: {
    moment,
    getdetilPO(val){
      this.loading.page = true;
      this.kurs = this.dataProcessed.information.nopowo.kurs;

        this.asyncAxiosGet(
            "payment_refund/data_trans",
            this.getAuth,
            {jenis:this.dataProcessed.information.jns_transaksi,
              id_trans:this.dataProcessed.information.nopowo.id_transaksi}
        ).then((response) => {
            this.list_dtl_pp = response.list_dtl_pp;
            this.total_origin = response.total_origin;
            if(val=="initial"){
              if (this.isModifiedDtl.id_transaksi!==this.dataProcessed.information.nopowo.id_transaksi){
                Event.$emit("setDetilPOpr", response.detail_po);
              }
            }else{
              Event.$emit("setDetilPOpr", response.detail_po);
            }
            this.loading.page = false;
        }).catch((err) => {
            console.log(err);
            this.loading.page = false;
        });
    },
    handleEditRow(item) {
      //console.log(item)
      this.modalForm.resetFields();
      this.editData = item;
      this.editModal = !this.editModal;
      this.trigered.is_item = item.is_item;
      this.trigered.disc = item.used_for == "1" ? true : false;
      let tot = 0;
      //console.log(item,this.kurs)
      tot =
        (item.jumlah ? item.jumlah : 0) *
        (item.harga ? item.harga : 0) *
        parseFloat(this.kurs);
      if (item.is_item == "no") {
        if (item.cur_type == "percentage") {
          let tdisc =
            item.used_for == "1" ||
            item.used_for == "3" ||
            item.used_for == "4"
              ? 0
              : this.totalDiscList;
          tot =
            (((this.totalPrice - tdisc) * item.harga) / 100) *
            parseFloat(this.kurs);
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);

      this.selectedPNm = item.item_pn;

      if (item.used_for == null) {
        this.kurangRataDiscountKeList(this.totalPrice, this.totalDiscList);
      }
      if (this.list_dtl_pp.length > 0) {
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          const elem = this.list_dtl_pp[index].id_pp_dtl;
          if (elem == item.selectedPPdtl) {
            this.list_dtl_pp[index].nilai_dtl_pp =
              parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) +
              tot;
          }
        }
      }
    },
    handleRemoveRow(item){
      const newPush = this.detilPO.filter(
        (valu) =>
          valu.item_name.concat(
            valu.selectedPPdtl
              ? valu.selectedPPdtl
              : valu.used_for
          ) !==
          item.nama_barang.concat(
            item.selectedPPdtl ? item.selectedPPdtl : item.used_for
          )
      );

      if (newPush.length > 0) {
        let nextpush = newPush.filter((valu) => valu.is_item == "yes");
        let discpush = newPush.filter(
          (valu) => valu.is_item == "no" && valu.used_for == "1"
        );
        if (nextpush.length == 0 && discpush.length > 0) {
          this.displayMessageValue(
            "error-other",
            "Purchase List Can't be empty, please delete all discount!"
          );
          this.newLoading = false;
          return;
        }
      }

      if (!this.simulation(newPush, "add")) {
        this.displayMessage("grather-remaining");
        this.newLoading = false;
        return;
      }

      let trig = false;
      if (item.used_for == "1") {
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          this.list_dtl_pp[index].temp_remove_val =
            this.list_dtl_pp[index].nilai_dtl_pp;
        }
        this.getdataSource.forEach((ment) => {
          let ppdtl = ment.selectedPPdtl;
          for (let index = 0; index < this.list_dtl_pp.length; index++) {
            const elem = this.list_dtl_pp[index].id_pp_dtl;
            if (elem == ppdtl) {
              let bsaran =
                (ment.hargaTotal / this.totalPrice) * item.hargaTotal;
              //console.log("-",ment.hargaTotal,this.totalPrice,item.hargaTotal)
              //console.log(this.list_dtl_pp[index].temp_remove_val,bsaran,this.list_dtl_pp[index].temp_remove_val-bsaran)
              if ((parseFloat(this.list_dtl_pp[index].temp_remove_val)).toFixed(2) - bsaran.toFixed(2) < 0) {
                trig = true;
                return;
              }
              this.list_dtl_pp[index].temp_remove_val =
                this.list_dtl_pp[index].temp_remove_val - bsaran;
            }
          }
        });
      }
      if (trig) {
        this.displayMessage("grather-remaining");
        return;
      } else {
        this.confirmMessageValue("confirm-delete", item, null);
      }
    },
    simulation(arr, poin, mode) {
      let result = true;
      if (this.list_dtl_pp.length > 0) {
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          this.list_dtl_pp[index].temp_nilai_dtl_pp =
            this.list_dtl_pp[index].nilai_dtl_pp_origin;
        }
      }
      if (arr.length > 0) {
        //menghitung total jumlah item terbaru
        let totalprice = 0;
        arr.forEach((ent) => {
          if (ent.is_item == "yes") {
            totalprice += parseFloat(ent.hargaTotal);
          }
        });
        //menghitung diskon terbaru
        let totaldisc = 0;
        arr.forEach((ent) => {
          if (ent.is_item == "no" && ent.used_for == "1") {
            totaldisc +=
              ent.cur_type == "currency"
                ? parseFloat(ent.hargaTotal)
                : (parseFloat(ent.harga) * totalprice) / 100;
          }
        });
        let totalpricedisc = totalprice - totaldisc;
        //short a to z
        arr.sort(function (a, b) {
          var x = a.key.toLowerCase();
          var y = b.key.toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        //console.log("short", arr);
        arr.forEach((ment) => {
          let ppdtl = ment.selectedPPdtl;
          for (let index = 0; index < this.list_dtl_pp.length; index++) {
            const elem = this.list_dtl_pp[index].id_pp_dtl;
            if (elem == ppdtl) {
              if (ment.cur_type == "percentage") {
                let hitung1 =
                  (parseFloat(ment.harga) *
                    (ment.used_for == "2"
                      ? totalpricedisc
                      : totalprice)) /
                  100;
                this.list_dtl_pp[index].temp_nilai_dtl_pp = (
                  parseFloat(this.list_dtl_pp[index].temp_nilai_dtl_pp) -
                  hitung1
                ).toString();
              } else {
                let hitung2 = parseFloat(ment.hargaTotal);
                this.list_dtl_pp[index].temp_nilai_dtl_pp = (
                  parseFloat(this.list_dtl_pp[index].temp_nilai_dtl_pp) -
                  hitung2
                ).toString();
              }
            }
          }
          if (ment.is_item == "no" && ment.used_for == "1") {
            if (ment.cur_type == "percentage") {
              let hitung3 = (totalprice * ment.harga) / 100;
              this.simulasibagiRataDiscountKeList(
                totalprice,
                hitung3,
                mode == "add" ? arr : this.detilPO
              );
            } else {
              this.simulasibagiRataDiscountKeList(
                totalprice,
                ment.harga,
                mode == "add" ? arr : this.detilPO
              );
            }
          }
        });

        this.list_dtl_pp.forEach((element) => {
          if (
            parseFloat(element.temp_nilai_dtl_pp) < 0 &&
            element.id_pp_dtl == poin.selectedPPdtl
          ) {
            result = false;
          }
        });

        let rcount = 0;
        //console.log("rcount", rcount, arr);
        arr.forEach((ment) => {
          if (ment.is_item == "yes") {
            rcount = rcount + parseFloat(ment.hargaTotal);
          }
          if (ment.is_item == "no" && ment.used_for == "1") {
            rcount =
              rcount -
              (ment.cur_type == "percentage"
                ? (parseFloat(ment.harga) * totalprice) / 100
                : parseFloat(ment.hargaTotal));
          }
          if (ment.is_item == "no" && ment.used_for == "2") {
            rcount =
              rcount +
              (ment.cur_type == "percentage"
                ? (parseFloat(ment.harga) * totalpricedisc) / 100
                : parseFloat(ment.hargaTotal));
          }
          if (
            ment.is_item == "no" &&
            ment.used_for !== "1" &&
            ment.used_for !== "2"
          ) {
            rcount =
              rcount +
              (ment.cur_type == "percentage"
                ? (parseFloat(ment.harga) * totalprice) / 100
                : parseFloat(ment.hargaTotal));
          }
          if (rcount < 0) {
            result = false;
          }
        });
      }
      return result;
    },
    delete(val) {
      const newPush = this.detilPO.filter(
        (item) =>
          item.item_name.concat(item.selectedPPdtl) !==
          val.nama_barang.concat(val.selectedPPdtl)
      );
      Event.$emit("setDetilPOpr", newPush);
    },
    handleEditModal(item) {
      // console.log(item)
      this.modalForm.resetFields();
      this.editData = item;
      this.editModal = !this.editModal;
      this.trigered.is_item = item.is_item;
      this.trigered.disc = item.used_for == "1" ? true : false;
      let tot = 0;
      tot =
        (item.jumlah ? item.jumlah : 0) *
        (item.harga ? item.harga : 0) *
        parseFloat(this.kurs);
      if (item.is_item == "no") {
        if (item.cur_type == "percentage") {
          let tdisc =
            item.used_for == "1" ||
            item.used_for == "3" ||
            item.used_for == "4"
              ? 0
              : this.totalDiscList;
          tot =
            (((this.totalPrice - tdisc) * item.harga) / 100) *
            parseFloat(this.kurs);
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);

      this.selectedPNm = item.item_pn;

      if (item.used_for == null) {
        this.kurangRataDiscountKeList(this.totalPrice, this.totalDiscList);
      }
      if (this.list_dtl_pp.length > 0) {
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          const elem = this.list_dtl_pp[index].id_pp_dtl;
          if (elem == item.selectedPPdtl) {
            this.list_dtl_pp[index].nilai_dtl_pp =
              parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) +
              tot;
          }
        }
      }
    },
    handleClose() {
      this.recountingBalance(this.detilPO, "remove");
      this.resetForm();
    },
    handleis_item(val) {
      if (val.target.value == "no") {
        this.trigered.is_item = "no";
        this.trigered.used_for = true;
        this.trigered.pn = false;
        this.trigered.cur = true;
        this.trigered.percentage = false;
        this.trigered.qty_unit = false;
        this.push = [];
        this.isAset = false;
      } else {
        this.trigered.is_item = "yes";
        this.trigered.used_for = false;
        this.trigered.pn = true;
        this.trigered.cur = false;
        this.trigered.percentage = false;
        this.trigered.qty_unit = true;
      }
      this.convert_value = 0;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleppdtl() {
    },
    handlePN(){

    },
    checkPrice(rule, value, callback) {
      if (value >= 0) {
        callback();
        return;
      }
      callback("Price must equals or greater than zero!");
    },
    convertingmodalqty(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot =
        (val ? val : vinput.jumlah) * vinput.harga * parseFloat(this.kurs);
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertingmodalhrg(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 0) *
        (val ? val : vinput.harga) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (vinput.cur_type == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot = ((this.totalPrice * val) / 100) * parseFloat(this.kurs);
          } else {
            let tdisc = vinput.used_for == "1" ? 0 : this.totalDiscList;
            tot =
              (((this.totalPrice - tdisc) * val) / 100) * parseFloat(this.kurs);
          }
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    handleUseFor(val) {
      if (val.target.value == "1") {
        this.trigered.disc = true;
      } else {
        this.trigered.disc = false;
      }
    },
    optionchange(val) {
      //console.log(val)
      let vinput = this.modalForm.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 0) *
        (vinput.harga ? vinput.harga : 0) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (val == "percentage") {
          let totdisc = 0;
          if (
            vinput.used_for == "1" ||
            vinput.used_for == "3" ||
            vinput.used_for == "4"
          ) {
            totdisc = 0;
          }
          tot =
            (((this.totalPrice - totdisc) * vinput.harga) / 100) *
            parseFloat(this.kurs);
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    recountingBalance(arr, mode) {
      if (this.list_dtl_pp.length > 0) {
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          this.list_dtl_pp[index].nilai_dtl_pp =
            this.list_dtl_pp[index].nilai_dtl_pp_origin;
        }
      }
      if (arr.length > 0) {
        //menghitung total jumlah item terbaru
        let totalprice = 0;
        arr.forEach((ent) => {
          if (ent.is_item == "yes") {
            totalprice += parseFloat(ent.hargaTotal);
          }
        });
        //menghitung diskon terbaru
        let totaldisc = 0;
        arr.forEach((ent) => {
          if (ent.is_item == "no" && ent.used_for == "1") {
            totaldisc +=
              ent.cur_type == "currency"
                ? parseFloat(ent.hargaTotal)
                : (parseFloat(ent.harga) * totalprice) / 100;
          }
        });
        let totalpricedisc = totalprice - totaldisc;
        //short a to z
        arr.sort(function (a, b) {
          var x = a.key;
          var y = b.key;
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        //console.log("short", arr);
        arr.forEach((ment) => {
          let ppdtl = ment.selectedPPdtl;
          for (let index = 0; index < this.list_dtl_pp.length; index++) {
            const elem = this.list_dtl_pp[index].id_pp_dtl;
            if (elem == ppdtl) {
              if (ment.cur_type == "percentage") {
                let hitung1 =
                  (parseFloat(ment.harga) *
                    (ment.used_for == "2"
                      ? totalpricedisc
                      : totalprice)) /
                  100;
                this.list_dtl_pp[index].nilai_dtl_pp = (
                  parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) - hitung1
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "%kurangi",
                //   ment.pp_nama_barang,
                //   hitung1,
                //   this.list_dtl_pp[index].nilai_dtl_pp,
                //   parseFloat(ment.harga),
                //   mode,
                //   totalpricedisc,
                //   "=",
                //   totalprice,
                //   this.totalDiscList
                // );
              } else {
                let hitung2 = parseFloat(ment.hargaTotal);
                this.list_dtl_pp[index].nilai_dtl_pp = (
                  parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) - hitung2
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "kurangi",
                //   ment.pp_nama_barang,
                //   hitung2,
                //   this.list_dtl_pp[index].nilai_dtl_pp
                // );
              }
            }
          }

          if (ment.is_item == "no" && ment.used_for == "1") {
            if (ment.cur_type == "percentage") {
              let hitung3 = (totalprice * ment.harga) / 100;
              this.bagiRataDiscountKeList(
                totalprice,
                hitung3,
                mode == "add" ? arr : this.detilPO
              );
            } else {
              this.bagiRataDiscountKeList(
                totalprice,
                ment.harga,
                mode == "add" ? arr : this.detilPO
              );
            }
          }
        });

        for (let index = 0; index < this.detilPO.length; index++) {
          const element = this.detilPO[index];
          if ("percentage" == element.cur_type) {
            if (element.used_for == "2") {
              this.detilPO[index].hargaTotal =
                (totalpricedisc * this.detilPO[index].harga) / 100;
            } else {
              this.detilPO[index].hargaTotal =
                (totalprice * this.detilPO[index].harga) / 100;
            }
          }
        }

        //menghitung pajak, shipping dan etc
        // arr.forEach(ment => {
        //   let ppdtl=ment.selectedPPdtl
        //   for (let index = 0; index < this.list_dtl_pp.length; index++) {
        //     const elem = this.list_dtl_pp[index].id_pp_dtl;
        //     if (elem==ppdtl && ment.used_for=="2"){
        //       if(ment.cur_type=="percentage"){
        //         this.list_dtl_pp[index].nilai_dtl_pp = (parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) -
        //           (parseFloat(ment.harga)*(totalprice)/100)).toString()
        //       }else{
        //         this.list_dtl_pp[index].nilai_dtl_pp = (parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) -
        //           parseFloat(ment.hargaTotal)).toString()
        //       }
        //     }
        //   }
        // });
      }
    },
    resetForm() {
      // this.form.resetFields();
      this.selectedPN = null;
      this.trigered.cur = false;
      this.trigered.disc = false;
      this.trigered.is_item = "yes";
      this.trigered.percentage = false;
      this.trigered.pn = true;
      this.trigered.qty_unit = true;
      this.trigered.used_for = false;
    },
    kurangRataDiscountKeList(total, val) {
      this.getdataSource.forEach((ment) => {
        let ppdtl = ment.selectedPPdtl;
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          const elem = this.list_dtl_pp[index].id_pp_dtl;
          if (elem == ppdtl && ment.used_for == null) {
            this.list_dtl_pp[index].nilai_dtl_pp =
              parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) -
              (parseFloat(ment.hargaTotal) * val) / total;
            break;
          }
        }
      });
    },
    simulasibagiRataDiscountKeList(total, val, arr) {
      //console.log("bagiRataDiscountKeList",total,val,arr)
      arr.forEach((ment) => {
        let ppdtl = ment.selectedPPdtl;
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          const elem = this.list_dtl_pp[index].id_pp_dtl;
          if (elem == ppdtl && ment.is_item == "yes") {
            this.list_dtl_pp[index].temp_nilai_dtl_pp =
              parseFloat(this.list_dtl_pp[index].temp_nilai_dtl_pp) +
              (parseFloat(ment.hargaTotal) / total) * val;
            // console.log(
            //   ment.key,
            //   index,
            //   "     - = ",
            //   this.list_dtl_pp[index].nilai_dtl_pp_origin,
            //   ment.hargaTotal,
            //   total,
            //   val,
            //   (parseFloat(ment.hargaTotal) / total) * val,
            //   this.list_dtl_pp[index].temp_nilai_dtl_pp
            // );
          }
        }
      });
    },
    bagiRataDiscountKeList(total, val, arr) {
      //console.log("bagiRataDiscountKeList",total,val,arr)
      arr.forEach((ment) => {
        let ppdtl = ment.selectedPPdtl;
        for (let index = 0; index < this.list_dtl_pp.length; index++) {
          const elem = this.list_dtl_pp[index].id_pp_dtl;
          if (elem == ppdtl && ment.is_item == "yes") {
            this.list_dtl_pp[index].nilai_dtl_pp =
              parseFloat(this.list_dtl_pp[index].nilai_dtl_pp) +
              (parseFloat(ment.hargaTotal) / total) * val;
            // console.log(
            //   ment.key,
            //   index,
            //   "     - = ",
            //   this.list_dtl_pp[index].nilai_dtl_pp_origin,
            //   ment.hargaTotal,
            //   total,
            //   val,
            //   (parseFloat(ment.hargaTotal) / total) * val,
            //   this.list_dtl_pp[index].nilai_dtl_pp
            // );
          }
        }
      });
    },
    getPN(params) {
      axios({
        method: "get",
        url: this.$serviceUrl + "po/assistPN",
        params: {
          filterString: params ? params : "",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataPN = response.data.listPN;
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-aktif-project");
        });
    },
    getAset(params) {
      axios({
        method: "get",
        url: this.$serviceUrl + "po/asetPN",
        params: {
          filterString: params ? params : "",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataAset = response.data.listPN;
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-aktif-project");
        });
    },
    handleModalEdit(id_key) {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        
        if (values.is_item == "no") {
          if (
            values.cur_type == "percentage" &&
            (this.getdataSource.length == undefined ||
              this.getdataSource.length == 0)
          ) {
            this.newLoading = false;
            this.displayMessage("empty-phurcaselist");
            return;
          }
        }
        //console.log(values.jumlah,this.editData.jumlah,this.editData.jumlah_terima,(this.editData.jumlah-this.editData.jumlah_terima))
        if (values.jumlah > (this.editData.jumlah_origin-this.editData.jumlah_terima)){
          this.displayMessageValue(
            "error-other",
            // "Min QTY is "+this.editData.jumlah_terima+", Max QTY is "
              "Max QTY is "+(this.editData.jumlah_origin-this.editData.jumlah_terima)+"!"
          );
          return;
        }

        if (this.selectedPNm && this.isObject(this.selectedPNm)) {
          this.selectedPNm = this.selectedPNm.item_pn_concat;
        }

        let findNames = null;
        if (values.used_for == "1") {
          findNames = _.filter(
            this.detilPO,
            (obj) =>
              obj.used_for &&
              obj.used_for.toLowerCase() ==
                values.used_for.toLowerCase() &&
              obj.item_name &&
              obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
          );
        } else {
          findNames = _.filter(
            this.detilPO,
            (obj) =>
              obj.selectedPPdtl &&
              obj.selectedPPdtl.toLowerCase() ==
                values.selectedPPdtl.toLowerCase() &&
              obj.item_name &&
              obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
          );
        }

        if (findNames.length > 0 && findNames[0].key !== id_key) {
          this.displayMessage("form-duplicate");
          return;
        } else {
          //validasi value entri
          let plafon = 0;
          let pp_nama_barang = "";
          let pp_kode_anggaran = "";
          let vmsk = 0;
          if (values.is_item == "yes") {
            vmsk = values.jumlah * values.harga;
          } else {
            vmsk =
              values.cur_type == "percentage"
                ? (values.harga * this.totalPrice) / 100
                : values.harga;
          }

          let dataExist = {};
          if (values.used_for == "1") {
            plafon = this.grandTotal;
          } else {
            this.list_dtl_pp.forEach((element) => {
              if (element.id_pp_dtl == values.selectedPPdtl) {
                plafon = parseFloat(element.nilai_dtl_pp);
                pp_nama_barang = element.nama_barang;
                pp_kode_anggaran = element.kode_anggaran;
              }
            });
          }
          //get discount exist
          dataExist = _.filter(
            this.detilPO,
            (obj) => obj.key && obj.key.toLowerCase() == id_key.toLowerCase()
          );

          let discExist = 0;
          if (dataExist) {
            discExist = dataExist.hargaTotal;
          }

          //validasi pajak : tidak boleh lebih dari total
          if (
            values.used_for == "2" &&
            (vmsk > this.totalPrice - (this.totalDiscList - discExist) ||
              vmsk > plafon)
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            return;
          }
          //validasi discount : tidak boleh lebih dari total
          if (
            values.used_for == "1" &&
            vmsk > this.totalPrice - (this.totalDiscList - discExist)
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            return;
          }
          //validasi selain pajak dan discount : tidak boleh lebih dari plafon
          //console.log("validasi -",vmsk,plafon)
          if (
            values.used_for !== "2" &&
            values.used_for !== "1" &&
            vmsk > plafon
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            // this.$nextTick(function () {
            //   this.modalForm.setFieldsValue({
            //     harga: null,
            //   });
            // });
            return;
          }

          // if (values.used_for=="1"){
          //   console.log("simulasiEditDiskon")
          //   let trig = this.simulasiEditDiskon(this.editData,values)
          //   if (!trig){
          //     this.displayMessage("grather-remaining");
          //     return
          //   }
          //   console.log("end simulasiEditDiskon")
          // }
          
          // if (this.isObject(this.selectedPNm)) {
          //   this.selectedPNm = this.selectedPNm.item_pn_concat;
          // }

          values.item_pn = this.selectedPNm;
          const newPush = this.detilPO.filter(
            (item) => item.key !== id_key
          );

          values.type_item = values.is_aset=="yes" ? "1" : "0";

          let hargaTotal = 0;
          if (values.is_item == "yes") {
            hargaTotal = values.jumlah * values.harga;
          } else {
            let valh = values.harga;
            if (values.used_for == "2") {
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh *
                      (this.totalPrice
                        ? this.totalPrice - this.totalDiscList
                        : 0)) /
                    100
                  : valh;
            } else {
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh * (this.totalPrice ? this.totalPrice : 0)) / 100
                  : valh;
            }
          }
          if(this.dataProcessed.information.jns_transaksi=='po'){
            values.id_po_dtl = this.editData.id_po_dtl;
          }else{
            values.id_wo_dtl = this.editData.id_wo_dtl;
          }
          values.hargaTotal =  hargaTotal;
          values.pp_nama_barang = pp_nama_barang;
          values.pp_kode_anggaran = pp_kode_anggaran;
          values.cur_type = this.editData.cur_type;
          values.currency = this.editData.currency;
          values.satuan = this.editData.satuan;
          values.type_item = this.editData.type_item ? this.editData.type_item : "";
          values.jumlah_terima = this.editData.jumlah_terima;
          values.jumlah_origin = this.editData.jumlah_origin;

          let isthis = [
            ...newPush,
            JSON.parse(JSON.stringify({ key: "other", values })),
          ];

          if (!this.simulation(isthis, values, "add")) {
            this.displayMessage("grather-remaining");
            this.newLoading = false;
            return;
          }

          let thenewPush = [
            ...newPush,
            JSON.parse(JSON.stringify(values)),
          ];
          
          //Event.$emit("setDetilPOpr", thenewPush);

          // Event.$emit("listPembelian", {
          //   key: id_key,
          //   hargaTotal: values.hargaTotal,
          //   item_name: values.nama_barang,
          //   selectedPPdtl: values.selectedPPdtl,
          //   unit_price: values.harga,
          //   values: values,
          // });
          this.editModal = !this.editModal;
          this.modalconvert_value = 0;
          this.resetForm();
          this.recountingPersentaseNonItem(thenewPush);
          this.displayMessageValue("update-item", values.nama_barang);
        }
      });
    },
    isObject(obj) {
      return obj === Object(obj);
    },
    handleAset(value) {
      const filter = _.filter(this.dataAset, (item) => {
        if (item.aset_pn === (value ? value.aset_pn : null)) {
          return item;
        }
      });
      if (!this.editModal) {
        if (filter.length === 0) {
          //this.selectedPN = "";
          this.form.setFieldsValue({
            nama_barang: "",
          });
        } else {
          this.selectedPN = filter[0].aset_pn;
          this.form.setFieldsValue({
            nama_barang: filter[0].aset_nm,
          });
        }
      } else {
        if (filter.length === 0) {
          // this.selectedPNm = "";
          this.modalForm.setFieldsValue({
            nama_barang: "",
          });
        } else {
          this.selectedPNm = filter[0].aset_pn;
          this.modalForm.setFieldsValue({
            nama_barang: filter[0].aset_nm,
          });
        }
      }
    },
    recountingPersentaseNonItem(val){
      //gettotalprice dan discount
      let _total = 0;
      let _totaldisc = 0;

      val.forEach((item) => {
        if(item.is_item=="yes"){
          _total = _total + item.hargaTotal;
          //console.log("totalhargaitem",item.hargaTotal)
        }
      });

      val.forEach((item) => {
        if (item.is_item=="no" && item.used_for == "1") {
          if(item.cur_type=="percentage"){
            _totaldisc = _totaldisc + (_total*item.harga)/100;
          }else{
            _totaldisc = _totaldisc + item.hargaTotal;
          }
        }
      });
      
      val.forEach((item) => {
        if (item.is_item=="no" && item.cur_type=="percentage"){
            if (item.cur_type == "percentage") {
              let tdisc =
                item.used_for == "1" ||
                item.used_for == "3" ||
                item.used_for == "4"
                  ? 0
                  : _totaldisc;
              item.hargaTotal =
                (((_total - tdisc) * item.harga) / 100) *
                parseFloat(this.kurs);
            }
          
        }
      });
      Event.$emit("setDetilPOpr", val);
    }
  },
  mounted() {
    Event.$on("confirmMessageDelete", this.delete);
    this.getdetilPO("initial");
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
  },
  beforeCreate() {
    this.modalForm = this.$form.createForm(this);
  },
};
</script>

<style lang="less">
  .head-table{
    color : @color-secondary;
    font-size: 16px;
    font-weight: 500;
  }

.m-price-total-refund{
  background: darken(white, 5);
  border: 1px solid #e4e0e0;
  padding: @padding;
}
</style>